import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '<',
        sites: '<',
        licences: '<'
    },
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <h1>{{ 'report.Licence report' | translate }}</h1>
            </div>
            <reports-licencereport-filter
              classifiers="vm.classifiers"
              sites="vm.sites"
              licences="vm.licences"
              list="vm.list"
              default-filter="vm.defaultFilter"
              filter="vm.filter"
              filter-overview="vm.filterOverview"
              ></reports-licencereport-filter>
            <div class="well">
                <div class="heading01">
                    <h2>{{ 'report.Report' | translate }}</h2>
                    <ul class="actions01">
                        <li ng-if="vm.PrivilegeService.canExportLicencePointsReport()">
                            <a ng-click="vm.exportCsv()" class="btn ico-download">{{ 'report.Export as csv' | translate }}</a>
                        </li>
                    </ul>
                </div>
                <reports-filter-overview filter-overview="vm.filterOverview"></reports-filter-overview>
                <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
                <p ng-if="!vm.list.loading && vm.list.items.length" class="desc">* {{ 'report.Fields apply to active period' | translate }}</p>
                <div class="mt20">
                    <table datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length" class="data01">
                        <thead>
                            <tr>
                                <th>{{ 'report.Employee name' | translate }}</th>
                                <th>{{ 'report.Licence name' | translate }}</th>
                                <th>{{ 'report.Licence status' | translate }}</th>
                                <th>{{ 'report.Entering deadline' | translate }} *</th>
                                <th>{{ 'report.Required points' | translate }} *</th>
                                <th>{{ 'report.Collected points' | translate }} *</th>
                                <th class="none dt-hide"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="item in vm.list.items">
                                <td>{{ item.displayName }}</td>
                                <td>{{ item.licenceName }}</td>
                                <td>{{ vm.USER_LICENCE_STATUS_ENUM.LABELS[item.licenceStatus] }}</td>
                                <td>{{ vm.MomentService.formatDate(item.activePeriodEnteringDate) }}</td>
                                <td>{{ item.activePeriodPointsPerPeriod }}</td>
                                <td>{{ item.activePeriodCollectedPoints }}</td>
                                <td>
                                    <div ng-repeat="licencePeriod in item.licencePeriods" class="well type02">
                                        <ul class="metablock in6cols">
                                            <li>
                                                <div class="label">{{ 'report.Licence period status' | translate }}</div>
                                                <div class="value">{{ vm.USER_LICENCE_PERIOD_STATUS_ENUM.LABELS[licencePeriod.periodStatus] }}</div>
                                            </li>
                                            <li>
                                                <div class="label">{{ 'report.Licence period entering deadline' | translate }}</div>
                                                <div class="value">{{ vm.MomentService.formatDate(licencePeriod.enteringDate) }}</div>
                                            </li>
                                            <li>
                                                <div class="label">{{ 'report.Licence period acquiring deadline' | translate }}</div>
                                                <div class="value">{{ vm.MomentService.formatDate(licencePeriod.acquiringDate) }}</div>
                                            </li>
                                            <li>
                                                <div class="label">{{ 'report.Required points' | translate }}</div>
                                                <div class="value">{{ licencePeriod.pointsPerPeriod }}</div>
                                            </li>
                                            <li>
                                                <div class="label">{{ 'report.Collected points' | translate }}</div>
                                                <div class="value">{{ licencePeriod.collectedPoints }}</div>
                                            </li>
                                        </ul>
                                        <table class="data01">
                                            <thead>
                                            <tr>
                                                <th>{{ 'report.Title' | translate }}</th>
                                                <th>{{ 'report.Points' | translate }}</th>
                                                <th>{{ 'report.Points obtainment date' | translate }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr ng-repeat="userLicencePoint in licencePeriod.userLicencePoints">
                                                <td>
                                                    <a ng-if="userLicencePoint.courseId" ui-sref="authorized.courses.courses.edit({ id: userLicencePoint.courseId })">
                                                        {{ userLicencePoint.title }}
                                                    </a>
                                                    <span ng-if="!userLicencePoint.courseId" >{{ userLicencePoint.title }}</span>
                                                </td>
                                                <td>{{ userLicencePoint.points }}</td>
                                                <td>{{ vm.MomentService.formatDate(userLicencePoint.obtainmentDate) }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination list="vm.list"></pagination>
                </div>
                <ul class="actions01">
                    <li ng-if="vm.PrivilegeService.canExportLicencePointsReport()">
                        <a ng-click="vm.exportCsv()" class="btn bordered02">{{ 'report.Export as csv' | translate }}</a>
                    </li>
                </ul>
            </div>
        </div>
    `
})
export default class {
    constructor ($window, DATATABLES, USER_LICENCE_STATUS_ENUM, USER_LICENCE_PERIOD_STATUS_ENUM, ListFactory, UserResource, AuthResource,
                 MomentService, PrivilegeService, ReportService, TokenService, LicenceService) {
        this.$window = $window;
        this.MomentService = MomentService;
        this.UserResource = UserResource;
        this.AuthResource = AuthResource;
        this.ListFactory = ListFactory;
        this.PrivilegeService = PrivilegeService;
        this.ReportService = ReportService;
        this.TokenService = TokenService;
        this.LicenceService = LicenceService;

        this.DATATABLES = DATATABLES;
        this.USER_LICENCE_STATUS_ENUM = USER_LICENCE_STATUS_ENUM;
        this.USER_LICENCE_PERIOD_STATUS_ENUM = USER_LICENCE_PERIOD_STATUS_ENUM;
    }

    $onInit () {
        this.filterOverview = {};
        this.filter = {};
        this.filter.siteIds = this.sites.map(site => site.id);
        this.filter.licenceIds = this.licences.map(licence => licence.id);
        this.filter.periodIds = this.LicenceService.getLicencePeriodIdsAsArray(this.licences);
        this.filter.statuses = [this.USER_LICENCE_STATUS_ENUM.KEYS.ACQUIRED, this.USER_LICENCE_STATUS_ENUM.KEYS.NOT_ACQUIRED];
        this.filter.periodStatuses = [this.USER_LICENCE_PERIOD_STATUS_ENUM.KEYS.ACQUIRED, this.USER_LICENCE_PERIOD_STATUS_ENUM.KEYS.NOT_ACQUIRED];

        this.defaultFilter = angular.copy(this.filter);

        this.list = this.ListFactory.createWithPagination(this.UserResource.licenceReport.bind(this.UserResource));
        this.list.fetch();
    }

    exportCsv () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const mapPostParamsAsGet = {
                    siteIds: 'siteIds[]',
                    periodIds: 'periodIds[]',
                    periodStatuses: 'periodStatuses[]',
                    statuses: 'statuses[]',
                    licenceIds: 'licenceIds[]'
                };

                const qs = this.ReportService.buildQueryString(this.filter, mapPostParamsAsGet);

                const lang = this.TokenService.getActiveLanguage(true);
                const url = `${SEED_CORE.ENV.API_URL}user/licence-point/export?tacToken=${token}&${qs}&_lang=${lang}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/licencereport/index.js